<template>
    <div class="mx-auto">
        <b-modal
            ref="modal-documentos-devedor"
            id="modal-documentos-devedor"
            size="xl"
            :content-class="'shadow ' + getTheme"
            title="Documentação do Devedor"
            header-bg-variant="success"
            header-text-variant="white"
            @hidden="hideModal('modal-documentos-devedor')">
            <template #modal-header="{ hide }">
                <h5 class="modal-title">Documentação do Devedor</h5>
                <b-button variant="success" @click="exportarDocumentos()" class="py-0 ml-auto"> <i class="far fa-file-pdf"></i> Imprimir</b-button>
                <button class="close text-white ml-1" @click="hide()" aria-label="close">&times;</button>
            </template>

            <CompFiltroGrid
                ref="compFiltroPesquisa"
                :filtro="filtro"
                compId="popupModal"
                @filtrarResultados="filtrarResultadosModal"
                @ordenarResultados="ordenarResultadosModal"/>

            <b-row class="overflow-grid-documentos">
                <b-table
                    id="documentos"
                    ref="tableDocumentos"
                    :items="listaDocumentos"
                    :fields="fieldsDocumentos"
                    striped
                    small
                    responsive="sm"
                    :busy="false"
                    show-empty
                    hover
                    bordered
                    sort-icon-left
                    class="mb-4 col-12 tabelaModal"
                    head-variant="light">
                    <div slot="table-busy" class="text-center text-primary my-2">
                        <b-spinner class="align-middle"></b-spinner>
                        <strong> Carregando...</strong>
                    </div>
                    <template slot="empty">
                        <p class="my-auto">Nenhuma parcela encontrada.</p>
                    </template>
                    <template v-slot:head(descricao)="{ item }">
                        Descrição <i class="filter" :class="!isEmpty(filtrosDocumentos.descricao) || filtrosDocumentos.filtrarDescricao == 3 ? 'fa fa-filter' : 'filter-empty'" @click="openFilterPopup('Descrição', 'texto', '', null, $event)"></i>
                    </template>
                    <template v-slot:head(arquivo)="{ item }">
                        Arquivo <i class="filter" :class="!isEmpty(filtrosDocumentos.arquivo) || filtrosDocumentos.filtrarArquivo == 5 ? 'fa fa-filter' : 'filter-empty'" @click="openFilterPopup('Arquivo', 'texto', '', null, $event)"></i>
                    </template>
                    <template v-slot:cell(arquivo)="{ item }">
                        <p class="coluna-resize text-left">
                            <a @click="downloadAnexo(item)">
                                {{ item.arquivo }}
                            </a>
                        </p>
                    </template>
                    <template v-slot:head(usuario)="{ item }">
                        Usuário <i class="filter" :class="!isEmpty(filtrosDocumentos.usuario) || filtrosDocumentos.filtrarUsuario == 5 ? 'fa fa-filter' : 'filter-empty'" @click="openFilterPopup('Usuário', 'texto', '', null, $event)"></i>
                    </template>
                    <template v-slot:head(dataInclusao)="{ item }">
                        Data Inclusão <i class="filter" :class="!isEmpty(filtrosDocumentos.dataVencimento) || filtrosDocumentos.filtrarDataVencimento == 5 ? 'fa fa-filter' : 'filter-empty'" @click="openFilterPopup('Data Inclusão', 'data', '', null, $event)"></i>
                    </template>
                    <template v-slot:head(excluir)="{ item }">
                        Excluir
                    </template>
                    <template v-slot:cell(excluir)="{ item }">
	                    <b-button class="ml-2"
	                              variant="outline-warning"
	                              v-if="acessoAdmin"
	                              @click="excluirArquivoModalDevedor(item)">
		                    <i class="fa fa-trash"></i>
	                    </b-button>
                    </template>
                </b-table>
            </b-row>

            <b-row class="mt-1 align-items-center">
                <b-col md="12">
                    <label>Anexar arquivo:</label>
                    <b-form-group id="input-group-1" label="" label-for="parcelamento">
                        <b-form-file id="carregarArqModal" v-model="arquivosModal" @input="realizarUploadAnexo"
                                     placeholder="Selecionar um arquivo"
                                     accept="image/png|image/jpeg|image/jpg|text/plain"></b-form-file>
                    </b-form-group>
                    <div class="msg-observacoes mb-1 invalid-feedback d-block" v-if="!validations.arquivo.valid">
                        {{ mensagemErroArquivo }}
                    </div>
                </b-col>
            </b-row>
            <b-row class="mt-1 align-items-center">
                <b-col md="12">
                    <label class="text-bold">Descrição:</label>
                </b-col>
            </b-row>
            <b-row class="mb-0">
                <b-col md="12">
                    <b-form-textarea
                        id="observacoes"
                        v-model="descricaoArquivo"
                        size="500"
                        placeholder="Resumo do conteúdo do(s) arquivo(s)"
                        max-rows="10"
                        :disabled="!validarAnexo()"
                    ></b-form-textarea>
                </b-col>
            </b-row>

            <template v-slot:modal-footer="{ hide }">
                <b-button variant="outline-secondary mr-auto" @click="hide()"> <i class="fa fa-reply"></i> Voltar</b-button>
                <b-button variant="outline-warning" @click="salvarAnexo" :disabled="!validarAnexo() || !validarDescricaoAnexo()" class="float-right"> <i class="fa fa-paperclip fa-flip-horizontal"></i> Anexar Arquivo</b-button>
            </template>
        </b-modal>
    </div>
</template>

<script>
    import axios from 'axios'
    import formatarMixins from '../../../mixins/formatarMixins';
    import CompFiltroGrid from "./CompFiltroGrid";

    export default {
        components: {CompFiltroGrid},
        props: ['loading'],
    mixins: [ formatarMixins ],
    data() {
        return {
            urlApi: null,
            token: null,
	        acessoAdmin: false,
            codContribuinte: null,
            mensagemErroArquivo: null,
            listaDocumentos: [],
            filtrosDocumentos: {
                descricao: null,
                filtrarDescricao: null,
                arquivo: null,
                filtrarArquivo: null,
                usuario: null,
                filtrarUsuario: null,
                dataVencimento: null,
                filtrarDataVencimento: null
            },
            filtro: {
                tipo: null,
                campoFiltro: null,
                filtrarEm: null,
                mascara: null,
                campoTexto: null,
                campoMascara: null,
                campoData: null,
                campoRadio: null,
                listaValores: []
            },
            fieldsDocumentos: [
                {
                    key: 'descricao',
                    label: 'Descrição'
                },
                {
                    key: 'arquivo',
                    label: 'Arquivo'
                },
                {
                    key: 'usuario',
                    label: 'Usuário'
                },
                {
                    key: 'dataInclusao',
                    label: 'Data Inclusão'
                }
            ],
            arquivoModal: null,
            arquivosModal: null,
            descricaoArquivo: null,
            validations: {
                arquivo: {
                    valid: true
                }
            }
        }
    },
    computed: {
        getTheme() {
            return this.$store.getters.getTheme
        }
    },
    methods: {
        abrirModal(documentoContribuinte, codContribuinte) {
            this.codContribuinte = codContribuinte;
            this.filtrosDocumentos = {
                documento: documentoContribuinte,
                descricao: null,
                filtrarDescricao: null,
                arquivo: null,
                filtrarArquivo: null,
                usuario: null,
                filtrarUsuario: null,
                dataVencimento: null,
                filtrarDataVencimento: null
            }

            this.limparModal();
            this.listarDocumentos();

            setTimeout(()=>{
                var tabelas = document.getElementsByClassName("tabelaModal");
                for (let i = 0; i < tabelas.length; i++) {
                    var inner = tabelas[i].children[0].children[0];
                    inner.style.position = 'sticky';
                    inner.style.top = '-2px';
                }
            }, 200);

            this.$refs['modal-documentos-devedor'].show();
        },
        listarDocumentos() {
            this.loading.showLoading();

            axios.post(`${this.urlApi}/v1/trp/listarAnexosContribuinte`, this.filtrosDocumentos, {
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': this.token
                }
            }).then(response => {
                this.listaDocumentos = response.data;
            }).finally(() => {
                this.loading.hideLoading();
            });
        },
        openFilterPopup(campo, tipo, values, mascara, event) {
            if(document.getElementById('popupModal').style.display != 'block'
                || this.filtro.campoFiltro != campo) {
                this.filtro.tipo = tipo;
                this.filtro.campoFiltro = campo;
                this.filtro.mascara = mascara;

                if(this.filtro.campoFiltro == 'Descrição') {
                    this.filtro.filtrarEm = this.filtrosDocumentos.filtrarDescricao;
                    this.filtro.campoTexto = this.filtrosDocumentos.descricao;
                } else if(this.filtro.campoFiltro == 'Arquivo') {
                    this.filtro.filtrarEm = this.filtrosDocumentos.filtrarArquivo;
                    this.filtro.campoTexto = this.filtrosDocumentos.arquivo;
                } else if(this.filtro.campoFiltro == 'Usuário') {
                    this.filtro.filtrarEm = this.filtrosDocumentos.filtrarUsuario;
                    this.filtro.campoTexto = this.filtrosDocumentos.usuario;
                } else if(this.filtro.campoFiltro == 'Data Inclusão') {
                    this.filtro.filtrarEm = this.filtrosDocumentos.filtrarDataVencimento;
                    this.filtro.campoData = this.filtrosDocumentos.dataVencimento;
                }

                if(this.filtro.tipo == "checkbox") {
                    this.filtro.listaValores = values;
                } else if(values != null && values != "") {
                    this.filtro.listaValores = values.split(',');
                }

                this.$refs.compFiltroPesquisa.openCloseFilterPopup(event, true, 385, 50);
            } else {
                this.$refs.compFiltroPesquisa.closeFilterPopup();
            }
        },
        filtrarResultadosModal(limpar) {
            if(limpar) {
                this.filtro.filtrarEm = null;
                this.filtro.campoTexto = null;
                this.filtro.campoData = null;
                this.filtro.campoRadio = null;
                this.filtro.campoCheckbox = null;
                this.filtro.campoMascara = null;
            }

            if(this.filtro.campoCheckbox != null && !Array.isArray(this.filtro.campoCheckbox)) {
                this.filtro.campoCheckbox = [this.filtro.campoCheckbox];
            }

            if(this.filtro.campoFiltro == 'Descrição') {
                this.filtrosDocumentos.filtrarDescricao = this.filtro.filtrarEm;
                this.filtrosDocumentos.descricao = this.filtro.campoTexto;
            } else if(this.filtro.campoFiltro == 'Arquivo') {
                this.filtrosDocumentos.filtrarArquivo = this.filtro.filtrarEm;
                this.filtrosDocumentos.arquivo = this.filtro.campoTexto;
            } else if(this.filtro.campoFiltro == 'Usuário') {
                this.filtrosDocumentos.filtrarUsuario = this.filtro.filtrarEm;
                this.filtrosDocumentos.usuario = this.filtro.campoTexto;
            } else if(this.filtro.campoFiltro == 'Data Inclusão') {
                this.filtrosDocumentos.filtrarDataVencimento = this.filtro.filtrarEm;
                this.filtrosDocumentos.dataVencimento = this.filtro.campoData;
            }

            this.listarDocumentos();
        },
        ordenarResultadosModal(order) {
            if(this.filtro.campoFiltro == 'Descrição') {
                this.filtrosDocumentos.sortField = 'descricao';
            } else if(this.filtro.campoFiltro == 'Arquivo') {
                this.filtrosDocumentos.sortField = 'arquivo';
            } else if(this.filtro.campoFiltro == 'Usuário') {
                this.filtrosDocumentos.sortField = 'usuario';
            } else if(this.filtro.campoFiltro == 'Data Inclusão') {
                this.filtrosDocumentos.sortField = 'data';
            }

            this.filtrosDocumentos.sortOrder = order;

            this.listarDocumentos();
        },
        async exportarDocumentos() {
            this.loading.showLoading();
            axios.post(`${this.urlApi}/v1/trp/exportarAnexos`, this.filtrosDocumentos, {
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': this.token
                },
                responseType: 'arraybuffer'
            })
                .then(response => {
                    let blob = new Blob([response.data], { type: 'application/pdf' });
                    let link = document.createElement('a');
                    link.href = window.URL.createObjectURL(blob);
                    link.download = 'DocumentosAnexos.pdf';
                    link.click();
                }).finally(() => {
                this.loading.hideLoading();
            })
        },
        downloadAnexo(item) {
            this.loading.showLoading();
            if (!item.trpGuiasAntigo) {
                axios.post(`${this.urlApi}/v1/trp/downloadAnexo`, item.caminho, {
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': this.token
                    }
                }).then(response => {
                    if(!response.data || !response.data.base64){
                        this.exibirMensagem('Arquivo não encontrado para download.');
                        this.loading.hideLoading();
                        return;
                    }

                    var a = document.createElement("a");
                    a.href = response.data.base64;
                    a.download = response.data.nomeArquivo;
                    a.click();
                    this.loading.hideLoading();
                }).catch((error) => {
                    this.exibirErro(error);
                    this.loading.hideLoading();
                });
            } else {
                axios.get(`${this.urlApi}/v1/trp/downloadAnexoGuias/${item.codDossieAnexo}`, {
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': this.token
                    }
                })
                    .then(response => {
                        if(!response.data || !response.data.base64){
                            this.exibirMensagem('Arquivo não encontrado para download.');
                            this.loading.hideLoading();
                            return;
                        }

                        var a = document.createElement("a");
                        a.href = response.data.base64;
                        a.download = response.data.nomeArquivo;
                        a.click();
                        this.loading.hideLoading();
                    }).finally(() => {
                    this.loading.hideLoading();
                })
            }
        },

        realizarUploadAnexo(arquivo) {
            if(arquivo != null) {
                this.arquivoModal = null;
                let arquivoConvertido = null;
                
                this.mensagemErroArquivo = null;

                this.listaDocumentos.forEach(doc => { 
                    if (doc.arquivo == arquivo.name) {
                        this.validations.arquivo.valid = false;
                        this.mensagemErroArquivo = "Já existe um arquivo com esse nome.";
                    }
                });

                if (!this.mensagemErroArquivo) {
                    if (arquivo.name.length > 45) {
                        this.validations.arquivo.valid = false;
                        this.mensagemErroArquivo = "O nome do arquivo é muito longo.";
                    } else {
                        if ((arquivo.size / 1024) / 1024 > 50.0) {
                            this.validations.arquivo.valid = false;
                            this.mensagemErroArquivo = "O documento selecionado ultrapassa o tamanho máximo permitido pelo sistema (50MB)!";
                        } else {
                            this.validations.arquivo.valid = true;
                            var reader = new FileReader()
                            reader.onload = function (e) {
                                arquivoConvertido = {
                                    nomeArquivo: arquivo.name,
                                    base64: e.target.result
                                }
                            }
                            reader.readAsDataURL(arquivo)
                            reader.onloadend = () => {
                                this.arquivoModal = arquivoConvertido;
                            }
                        }
                    }
                }
            }
        },
        validarAnexo() {
            return !(this.arquivoModal == null || !this.validations.arquivo.valid);
        },
        validarDescricaoAnexo() {
            return !(this.verificarValorVazio(this.descricaoArquivo));
        },
        limparModal () {
            this.descricaoArquivo = null;
            this.arquivosModal = null;
            this.arquivoModal = null;
            this.validations.arquivo.valid = true;
        },
        salvarAnexo () {
            let anexo = {
                codContribuinte: this.codContribuinte,
                descricao: this.descricaoArquivo,
                anexoVO: this.arquivoModal
            }

            this.loading.showLoading();
            axios.post(`${this.urlApi}/v1/trp/salvarAnexoContribuinte`, anexo, {
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': this.token
                }
            }).then(() => {
                this.limparModal();
                this.loading.hideLoading();
                this.listarDocumentos();
            }).catch((error) => {
                this.exibirErro(error);
                this.loading.hideLoading();
            })
        },
	    isShow() {
		    return this.$refs['modal-documentos-devedor'].isShow;
	    },
	    excluirArquivoModalDevedor (item) {
		    this.loading.showLoading();

		    axios.post(`${this.urlApi}/v1/trp/excluirAnexo`, item, {
			    headers: {
				    'Content-Type': 'application/json',
				    'Authorization': this.token
			    }
		    }).then(response => {
			    this.listarDocumentos();
		    }).finally(() => {
			    this.loading.hideLoading();
		    });
	    },
    },
    mounted() {
        this.urlApi = process.env.VUE_APP_ROOT_API;
        this.token = JSON.parse(this.$store.getters.getUser).access_token;

	    let userData = JSON.parse(this.$store.getters.getUser);
	    this.acessoAdmin = false;
	    if (userData.groups) {
		    for (let i = 0; i < userData.groups.length; i++) {
			    if(userData.groups[i] == 'SFEPGE-ADMINISTRADOR') {
				    this.acessoAdmin = true;
					this.fieldsDocumentos = [
						{
							key: 'descricao',
							label: 'Descrição'
						},
						{
							key: 'arquivo',
							label: 'Arquivo'
						},
						{
							key: 'usuario',
							label: 'Usuário'
						},
						{
							key: 'dataInclusao',
							label: 'Data Inclusão'
						},
						{
							key: 'excluir',
							label: 'Excluir'
						}
					];
			    }
		    }
	    }
    }

}
</script>

<style scoped>

.no-line {
    white-space: nowrap;
}

.icon-button {
    font-size: 1.5rem;
}

</style>
